import { useId } from 'react';

/**
 * A small wrapper around `React.useId()` that allows passing in a provided id,
 * which if given will be used instead of the generated id.
 */
function useIdOrProvided(idIn) {
    const internalId = useId();
    return idIn ?? internalId;
}

export { useIdOrProvided };
//# sourceMappingURL=use-id-or-provided.js.map
